<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import type { ComboboxGroupProps } from "radix-vue";
import { ComboboxGroup, ComboboxLabel } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<
	ComboboxGroupProps & {
		class?: HTMLAttributes["class"];
		heading?: string;
	}
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
    <ComboboxGroup v-bind="delegatedProps"
        :class="cn('overflow-hidden p-1 text-textForeground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-textForeground', props.class)">
        <ComboboxLabel v-if="heading" class="px-2 py-1.5 text-xs font-medium text-textForeground">
            {{ heading }}
        </ComboboxLabel>
        <slot />
    </ComboboxGroup>
</template>
